// extracted by mini-css-extract-plugin
export var actionIcon = "_s9-0";